import api from './'

export default {

    /**
     * Update event
     * @param eventId
     */
    update(eventId, data) {
        return api
            .put(`/events/${eventId}`, data)
            .then(response => {
                return response.data
            });
    },

    /**
     * Delete event
     * @param eventId
     */
    delete(eventId) {
        return api
            .delete(`/events/${eventId}`)
            .then(response => {
                return response.data
            });
    },

    /**
     * Make event recurring
     * @param eventId
     */
    makeRecurring(eventId, data) {
        return api
            .post(`/events/${eventId}/makeRecurring`, data)
            .then(response => {
                return response.data
            });
    },

    /**
     * Disable event recurring
     * @param eventId
     */
    disableRecurring(eventId, data) {
        return api
            .post(`/events/${eventId}/disableRecurring`, data)
            .then(response => {
                return response.data
            });
    }

}
